import { CSSProperties } from "react";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@material-ui/lab";
import { useRegistrationStyles } from "../../register-user/registrationStyles";
interface TimelineWrapperProps {
  stepIcon: number | JSX.Element;
  title: string;
  children: JSX.Element;
  style?: CSSProperties
};

export const TimelineWrapper = ({
  stepIcon,
  title,
  children,
  style
}: TimelineWrapperProps) => {
  const classes = useRegistrationStyles();

  return (
    <Timeline classes={{ root: classes.timelineRoot }} style={style} >
      <TimelineItem>
        <TimelineSeparator>
          <TimelineDot
            classes={{
              defaultPrimary: classes.timelineDot,
            }}
            color="primary"
            style={{ margin: "auto" }}
          >
            {stepIcon}
          </TimelineDot>
          <TimelineConnector
            classes={{
              root: classes.timelineConnector,
            }}
          />
        </TimelineSeparator>
        <TimelineContent className={classes.timelineContent}>
          <div
            className={classes.timelineTitle}
            style={{ position: "relative", bottom: "5px", marginBottom: "0px" }}
          >
            {title}
          </div>
          {children}
        </TimelineContent>
        <TimelineOppositeContent
          style={{
            display: "none",
          }}
        />
      </TimelineItem>
    </Timeline>
  );
};
